module.exports = __webpack_public_path__ + "img/nowire.cc3b8cad.svg";